{
  "web": {
    "desktopTitle": "REPAS is a mobile app",
    "desktopMessage": "Scan this code with your phone camera.",
    "desktopQrLabel": "QR code to app.repaschallenge.ch"
  },
  "common": {
    "ok": "OK",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "validate": "Confirm",
    "send": "Send",
    "errorTitle": "Error",
    "genericErrorMessage": "Something went wrong. Please try again later.",
    "pointsShort": "{{points}} pts",
    "save": "Save",
    "confirm": "Confirm",
    "delete": "Delete",
    "successTitle": "Success",
    "pointsFull": "{{points}} points",
    "linkErrorTitle": "Can’t open the link",
    "linkErrorMessage": "No app available to open this link.",
    "noEmailAppTitle": "No email app",
    "continue": "Continue",
    "later": "Later",
    "loading": "Loading...",
    "validation": {
      "emailRequired": "Email address is required",
      "emailInvalid": "Invalid email address",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Your password must be at least 8 characters long",
      "passwordUppercase": "Your password must contain at least one uppercase letter",
      "passwordLowercase": "Your password must contain at least one lowercase letter",
      "passwordDigit": "Your password must contain at least one number",
      "fieldRequired": "{{field}} is required",
      "fieldMinLength": "{{field}} must be at least 2 characters long",
      "fieldLettersOnly": "{{field}} can only contain letters",
      "genericFieldLabel": "This field",
      "postalCodeFieldLabel": "Postal code",
      "companyFieldLabel": "Company",
      "termsRequired": "You need to accept the terms and conditions"
    },
    "supabaseErrors": {
      "invalidCredentials": {
        "title": "Can’t log in",
        "message": "Incorrect email address or password. Please check your details and try again."
      },
      "emailNotConfirmed": {
        "title": "Email not confirmed",
        "message": "A confirmation email was sent when you signed up. For security reasons, click the confirmation link in that email before logging in.\n\nDidn’t get it? Remember to check your spam folder."
      },
      "userAlreadyRegistered": {
        "title": "Account already exists",
        "message": "An account already exists with this email address. You can log in directly, or use “Forgot password” if needed."
      },
      "weakPassword": {
        "title": "Password too weak",
        "message": "For security reasons, your password must be at least 8 characters long and include an uppercase letter, a lowercase letter and a number."
      },
      "pwnedPassword": {
        "title": "Password too common",
        "message": "This password appears in known data breaches, which makes it easy to guess. Choose a different one: it can follow exactly the same rules, it just needs to be less common."
      },
      "rateLimit": {
        "title": "Too many attempts",
        "message": "For security reasons, login attempts have been temporarily blocked. Please wait a few minutes before trying again."
      },
      "invalidEmail": {
        "title": "Invalid email",
        "message": "The email address you entered isn’t valid. Please check the format and try again."
      },
      "userNotFound": {
        "title": "Account not found",
        "message": "No account is associated with this email address. Would you like to create one?"
      },
      "linkExpired": {
        "title": "Link expired",
        "message": "This link has expired for security reasons. Please request a new reset link."
      },
      "network": {
        "title": "Connection problem",
        "message": "Couldn’t reach the server. Please check your internet connection and try again."
      },
      "accountExists": {
        "title": "Account already exists",
        "message": "These details are already linked to an account. Please log in or use a different email."
      },
      "invalidData": {
        "title": "Invalid information",
        "message": "Some of the information isn’t valid. Please check the fields and try again."
      },
      "accessDenied": {
        "title": "Access denied",
        "message": "You don’t have the permissions needed to perform this action."
      },
      "sessionExpired": {
        "title": "Session expired",
        "message": "Your session has expired. Please log in again to continue."
      },
      "signupFailed": {
        "title": "Sign-up failed",
        "message": "We couldn’t create your account. Please check your details and try again in a moment."
      },
      "unknown": {
        "title": "Something went wrong",
        "message": "Something didn’t go as planned. Please try again in a moment — if the problem persists, contact support."
      },
      "profileDuplicate": {
        "title": "Details already in use",
        "message": "These details are already used by another account. Please use different information."
      }
    },
    "moreInfo": "More info",
    "plusPointsShort": "+{{points}} pts"
  },
  "dates": {
    "weekdayShort0": "Sun",
    "weekdayShort1": "Mon",
    "weekdayShort2": "Tue",
    "weekdayShort3": "Wed",
    "weekdayShort4": "Thu",
    "weekdayShort5": "Fri",
    "weekdayShort6": "Sat",
    "month1": "January",
    "month2": "February",
    "month3": "March",
    "month4": "April",
    "month5": "May",
    "month6": "June",
    "month7": "July",
    "month8": "August",
    "month9": "September",
    "month10": "October",
    "month11": "November",
    "month12": "December",
    "challengeDayFormat": "{{weekday}} {{day}} {{month}}",
    "challengeRangeSameMonth": "From {{startDay}} to {{endDay}} {{month}}",
    "challengeRangeTwoMonths": "From {{startDay}} {{startMonth}} to {{endDay}} {{endMonth}}",
    "todaySuffix": "(today)"
  },
  "login": {
    "welcomeTitle": "Welcome!",
    "emailPlaceholder": "Email address",
    "passwordPlaceholder": "Password",
    "forgotPasswordLink": "Forgot password?",
    "loginButton": "Log in",
    "noAccountYet": "Don't have an account yet? ",
    "signUpLink": "Sign up",
    "emailNotConfirmedTitle": "Email not confirmed",
    "emailNotConfirmedMessage": "Your email address hasn't been confirmed yet. Resend the confirmation email?",
    "resendEmailButton": "Resend email",
    "resendEmailFailedRetry": "Couldn't resend the email. Please try again later.",
    "resendEmailFailed": "Couldn't resend the email.",
    "emailSentTitle": "Email sent! ✉️",
    "confirmationEmailSentMessage": "A new confirmation email has been sent to {{email}}. Remember to check your inbox (and your spam folder).",
    "accountDeletedTitle": "Account deleted",
    "accountDeletedMessage": "This account has been deleted. If this is a mistake, please contact support.",
    "resetEmailRequired": "Email address required",
    "emailInvalid": "Invalid email",
    "resetEmailSentMessage": "An email with a link to reset your password has been sent. Remember to check your inbox (and your spam folder if needed).",
    "forgotPasswordModalTitle": "Forgot password",
    "forgotPasswordModalDescription": "Enter your email address to receive a password reset link."
  },
  "createAccount": {
    "companyPlaceholder": "Company (optional)",
    "acceptTerms": "I accept the <termsLink>terms and conditions</termsLink> and the <privacyLink>privacy policy</privacyLink>",
    "alreadyRegistered": "Already have an account? ",
    "emailExistsTitle": "This account already exists",
    "emailExistsMessage": "An account is already linked to this email address. Log in to continue, or use “Forgot password?” if needed.",
    "confirmEmailTitle": "Welcome to the REPAS challenge! 🎉",
    "confirmEmailMessage": "You’re almost signed up!\n\nA confirmation email has been sent to {{email}}.\n\nClick the link in the email, then log in to start the REPAS challenge.\n\nNote: remember to check your spam folder if the email doesn’t show up.",
    "understoodButton": "Got it!",
    "selectCompanyTitle": "Select a company",
    "searchCompanyPlaceholder": "Search a company",
    "addCompany": "Add “{{query}}”",
    "noCompanyFound": "No company found",
    "passwordValidator": {
      "minLength": "At least 8 characters",
      "uppercase": "At least one uppercase letter",
      "lowercase": "At least one lowercase letter",
      "digit": "At least one number",
      "secure": "Strong password"
    }
  },
  "resetPassword": {
    "title": "New password",
    "subtitle": "Create a new secure password",
    "newPasswordPlaceholder": "New password",
    "confirmPasswordPlaceholder": "Confirm password",
    "passwordMismatch": "The passwords don’t match",
    "requirementsTitle": "Your password must contain:",
    "requirementMinLength": "• At least 8 characters",
    "requirementUppercase": "• An uppercase letter",
    "requirementLowercase": "• A lowercase letter",
    "requirementDigit": "• A number",
    "submitButton": "Reset password",
    "backToLogin": "Back to login",
    "linkExpiredTitle": "Link expired ⏱️",
    "linkExpiredMessage": "This reset link has expired for security reasons.\n\nDon’t worry! Go back to the login screen and tap “Forgot password?” again to receive a new link.",
    "successTitle": "Password reset! ✅",
    "successMessage": "Perfect! Your password has been updated.\n\nYou can now log in with your new password."
  },
  "confirmation": {
    "title": "Email confirmed ✅",
    "subtitle": "Your email address is verified. Log in to take part in the REPAS Challenge.",
    "loginButton": "Log in",
    "verifying": "Verifying your email address…",
    "errorText": "This confirmation link is no longer valid. Try logging in anyway: if your address has already been verified, it will work. Otherwise, request a new email from the login screen.",
    "errorTitle": "Link already used or expired"
  },
  "onboarding": {
    "dateRange": "SEPTEMBER 14–25,\n2026",
    "stepProgress": "Step {{current}} of {{total}}",
    "next": "Next",
    "start": "Let’s go!",
    "step1": {
      "title": "Welcome to the\nREPAS challenge app!",
      "description": "The challenge for local, balanced, zero-waste eating.",
      "credit": "An initiative by the State of Geneva, in partnership with committed local organisations."
    },
    "step2": {
      "title": "Points every day\nand prizes to win!",
      "description": "Complete actions, accomplish missions and try the wheel of luck to win lots of gifts and prizes.",
      "highlight": "More than CHF 5'000.- to be won!"
    },
    "step3": {
      "title": "One last step:\ncreate an account!",
      "description": "The final step before trying to win your first prize, right after signing up."
    }
  },
  "onboardingWheel": {
    "readyTitle": "Your first prize is on us",
    "readySubtitle": "Spin the wheel: bonus points and an entry in the prize draw, guaranteed.",
    "spinCta": "Spin the wheel",
    "spinning": "Spinning...",
    "doneTitle": "Well done!",
    "doneSubtitle": "{{amount}} points will be credited as soon as you create your account, plus a free entry in the prize draw!",
    "bonusPointsPill": "⭐️ {{amount}} points",
    "bonusEntryPill": "🎁 Entry in the prize draw",
    "formTitle": "Your gift 🎁",
    "formSubtitle": "Enter your email address to take part in the prize draw. More than CHF 5'000.- to be won!",
    "emailLabel": "Email",
    "emailPlaceholder": "name@email.com",
    "emailAccessibilityLabel": "Email address",
    "emailInvalid": "Invalid email address.",
    "formHint": "Your entry will be saved when you create your account. Your email is only used for the prize draw.",
    "submitButton": "Confirm my entry",
    "lockedTitle": "The wheel opens on 14 September",
    "lockedSubtitle": "You can spin the wheel when the challenge starts. Create your account now so you’re ready.",
    "lockedCta": "Create my account"
  },
  "notificationPermission": {
    "title": "Stay in the loop",
    "subtitle": "Turn on notifications to get the most out of your REPAS experience",
    "benefitDailyTitle": "Daily reminder",
    "benefitDailyDescription": "So you don’t miss the daily challenges and goals",
    "benefitSuccessTitle": "Wins worth celebrating",
    "benefitSuccessDescription": "Get notified as soon as you reach a goal",
    "benefitCommunityTitle": "Community challenges",
    "benefitCommunityDescription": "News about upcoming challenges and events",
    "benefitRewardsTitle": "Exclusive rewards",
    "benefitRewardsDescription": "Be the first to discover special offers",
    "privacyNote": "You can turn them off anytime.",
    "enableButton": "Turn on notifications",
    "webTitle": "Welcome to REPAS",
    "webSubtitle": "You can take part in the challenge directly from your browser.",
    "webBenefitTitle": "Web version",
    "webBenefitDescription": "All challenge features are available. Push reminders are not yet available in the browser.",
    "webPrivacyNote": "Add this page to your iPhone Home Screen for easy access."
  },
  "rankingConsent": {
    "title": "Overall ranking",
    "subtitle": "Appear in the overall ranking of your company and the REPAS community?",
    "benefitProgressTitle": "Visible progress",
    "benefitProgressDescription": "See your rank among the other participants",
    "benefitMotivationTitle": "Team motivation",
    "benefitMotivationDescription": "Compare yourself with your colleagues to stay motivated",
    "benefitAnonymousTitle": "Anonymous mode",
    "benefitAnonymousDescription": "If you decline, you can still see the ranking without appearing in it",
    "privacyNote": "You can change this anytime in the settings.",
    "acceptButton": "Yes, I want to appear",
    "declineButton": "No, I’ll stay invisible",
    "sessionExpiredTitle": "Session expired",
    "sessionExpiredMessage": "Log in again to continue.",
    "saveErrorMessage": "Couldn’t save your choice. Check your connection and try again."
  },
  "tabs": {
    "challenge": "Challenge",
    "missions": "Missions",
    "ranking": "Ranking",
    "profile": "Profile"
  },
  "home": {
    "weeklyRecap": {
      "emptyTitle": "No actions checked off yet",
      "emptySubtitle": "Check off your first actions in the “Daily” tab: they'll show up here, added up over the whole challenge.",
      "seeProfileButton": "See my profile",
      "bonusTitle": "Bonus",
      "completedLines_one": "Complete line: {{count}} × {{points}} pts",
      "completedLines_other": "Complete lines: {{count}} × {{points}} pts",
      "actionRow": "{{count}}× {{name}}",
      "totalLabel": "Challenge total"
    },
    "tabDaily": "Daily",
    "tabWeekly": "Week",
    "title": "Your actions",
    "streakDays_one": "{{count}} day",
    "streakDays_other": "{{count}} days",
    "streakA11y_one": "{{count}} day in a row",
    "streakA11y_other": "{{count}} days in a row",
    "validateNotToday": "Validation only on the same day",
    "validateWithBonus": "Confirm ({{actionPoints}} + {{bonus}} bonus = {{total}} pts)",
    "validateWithPoints": "Confirm ({{points}} points)",
    "saveFailedTitle": "Save failed",
    "saveFailedMessage": "Couldn’t save your actions. Please try again in a moment.",
    "pointsNotCreditedTitle": "Points not credited",
    "pointsNotCreditedMessage": "Your actions were saved, but crediting the points failed. Check your connection — the total will re-sync on the next load.",
    "actionInfo": {
      "learnMore": "Learn more",
      "learnMoreWithLabel": "Learn more: {{label}}"
    },
    "intro": {
      "title": "Welcome to the REPAS challenge!",
      "p1": "The REPAS challenge is 9 actions to complete by September 25.",
      "p2": "To enter the prize draws and win gifts, you need to complete at least one action.",
      "p3": "Every action earns points. The goal is to score as many points as possible and complete all 9 actions.",
      "p4": "Every day, gifts are up for grabs with the wheel of luck. From Monday to Friday, a quiz and a resource to explore are added.",
      "cta": "Let’s go!"
    }
  },
  "quiz": {
    "loading": "Loading missions...",
    "emptyTitle": "No questions",
    "emptyText": "The questions will be available soon!",
    "title": "Challenge missions",
    "subtitle": "Answer today’s mission!",
    "allDoneTitle": "Today’s missions complete!",
    "allDoneText": "All of today’s missions are done, well done! See you on the next challenge day.",
    "dayTitle": "Quiz for {{day}}",
    "bonusUpTo": "up to {{points}} bonus pts",
    "correctFeedback": "Correct! +{{points}} pts",
    "incorrectFeedback": "Wrong answer",
    "appToTest": "App to try",
    "openAppA11y": "Open {{name}}",
    "markTestedA11y": "Mark {{name}} as tested",
    "alreadyTestedA11y": "{{name}} already tested",
    "alreadyTested": "Already tried",
    "iTested": "I tried it",
    "testedAlertTitle": "Well done! 🎉",
    "testedAlertMessage": "Thanks for trying today’s app.\n\n+{{points}} pts",
    "card": {
      "stateCorrect": "Answered correctly",
      "stateIncorrect": "Incorrect",
      "stateNotAnswered": "Not answered",
      "questionNumber": "Question {{number}}",
      "feedbackCorrect": "Correct!",
      "feedbackIncorrect": "Incorrect answer"
    },
    "siteToDiscover": "Page to explore",
    "iVisited": "I read it",
    "alreadyVisited": "Already read",
    "visitedAlertMessage": "Thanks for exploring today’s resource.\n\n+{{points}} pts",
    "weekendTitle": "Weekend break",
    "weekendText": "No mission on Saturday and Sunday. Daily actions stay open — see you on Monday for the rest."
  },
  "ranking": {
    "headerTitle": "Ranking",
    "loading": "Loading the ranking...",
    "tabCompany": "My company",
    "tabGlobal": "Global",
    "myPositionLabel": "My position",
    "noCompanyTitle": "No company",
    "noCompanyText": "Join a company to see how your colleagues rank!",
    "chooseCompanyButton": "Choose a company",
    "emptyCompanyTitle": "No participants yet",
    "emptyCompanyText": "Be the first to rack up points in your company!",
    "globalSoonTitle": "Coming soon",
    "globalSoonText": "The global ranking will be available very soon!",
    "waitingTitle": "Ranking opens on 14 September",
    "waitingText": "Everyone starts from zero. The ranking appears when the challenge begins.",
    "waitingA11y": "{{days}} days, {{hours}} hours, {{minutes}} minutes and {{seconds}} seconds remaining.",
    "countdownDays": "d",
    "countdownHours": "h",
    "countdownMinutes": "min",
    "countdownSeconds": "s"
  },
  "profile": {
    "headerTitle": "Profile",
    "loadingProfile": "Loading your profile...",
    "addFirstName": "Add your first name",
    "totalPointsLabel": "Total points",
    "linkGifts": "Gifts",
    "linkPartners": "Partners",
    "linkAbout": "Our approach",
    "linkGoFurther": "Going further",
    "linkTerms": "Terms of use",
    "linkPrivacy": "Data protection",
    "weeklyObjectiveTitle": "Your weekly goal",
    "noObjectives": "No goal set yet. Head to “Your actions” to pick one!",
    "currentMedalTitle": "Current medal",
    "medalBronze": "Bronze",
    "medalSilver": "Silver",
    "medalGold": "Gold",
    "medalRangeBronze": "0-3 actions",
    "medalRangeSilver": "4-6 actions",
    "medalRangeGold": "7-9 actions"
  },
  "settings": {
    "headerTitle": "Preferences",
    "editProfile": "Edit profile",
    "notifications": "Notifications",
    "language": "Language",
    "languageAuto": "Automatic",
    "languageAutoSubtext": "Device language",
    "languageFrench": "Français",
    "languageEnglish": "English",
    "rankingVisibility": "Appear in the ranking",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "showRankingTitle": "Appear in the ranking",
    "hideRankingTitle": "Hide from the ranking",
    "showRankingMessage": "You will be visible in your company and community rankings.",
    "hideRankingMessage": "You can still view the ranking, but you won’t appear in it.",
    "visibilityChangedTitle": "Updated",
    "visibleInRanking": "Visible in the ranking",
    "hiddenFromRanking": "Hidden from the ranking",
    "visibilityError": "Couldn’t update your visibility",
    "reportBug": "Report a bug",
    "bugEmailSubject": "Bug report - REPAS App",
    "bugEmailBody": "Hello,\n\nI would like to report the following bug:\n\n[Describe the problem here]\n\n---\nTechnical information:\n- App version: {{appVersion}}\n- Platform: {{platform}}\n- OS version: {{osVersion}}\n",
    "bugNoEmailAppMessage": "Couldn’t open your email app. You can send your report to app@repaschallenge.ch.",
    "deleteAccountMenu": "Delete account and data",
    "logout": "Log out",
    "fillAllFields": "Please fill in all the fields",
    "editNameTitle": "Edit name",
    "nameUpdated": "Name updated successfully",
    "nameUpdateError": "Couldn’t update your name",
    "postalCodeLabel": "Postal code",
    "deleteAccountTitle": "Delete account",
    "deleteAccountMessage": "In accordance with the GDPR and the Swiss FADP, all your personal data will be permanently deleted from our servers.\n\nThis action cannot be undone. Confirm deletion?",
    "sessionError": "Couldn’t retrieve your session",
    "accountDeletedTitle": "Account deleted",
    "accountDeletedMessage": "Your account and personal data have been deleted in accordance with the GDPR.",
    "deleteError": "Something went wrong while deleting your account"
  },
  "notifications": {
    "headerTitle": "Notifications",
    "infoText": "Customize your notifications to stay motivated without being disturbed",
    "typesTitle": "Notification types",
    "permissionWarningTitle": "Notifications disabled",
    "permissionWarningText": "Enable notifications in your device settings to receive reminders.",
    "openSettings": "Open settings",
    "quizTitle": "Daily quiz",
    "quizSubtext": "Every day at 9am",
    "objectivesTitle": "Goal reminders",
    "objectivesSubtext": "3x a day (10:30am, 2pm, 6pm)",
    "wheelTitle": "Wheel of fortune",
    "wheelSubtext": "Every day at 7pm",
    "footerText": "Notifications help you stay on track by reminding you to check off your daily actions.",
    "actionsTitle": "Actions",
    "reregisterToken": "Re-register the push token",
    "sendTest": "Send a test notification",
    "updateError": "Couldn’t update your preferences",
    "tokenSavedTitle": "Success ✅",
    "tokenSavedMessage": "Push token registered successfully!",
    "tokenSaveError": "Couldn’t register the token",
    "tokenPermissionError": "Couldn’t get the token. Notifications must be enabled in your device settings.",
    "testSentTitle": "Sent ✅",
    "testSentMessage": "A test notification will arrive in 2 seconds!",
    "testError": "Couldn’t send the test notification",
    "testPushTitle": "Test Notification 📬",
    "testPushBody": "Your notifications are working!",
    "enableNow": "Enable notifications"
  },
  "editProfile": {
    "headerTitle": "Edit profile",
    "imageHint": "Tap to change your photo",
    "firstNameLabel": "First name *",
    "firstNamePlaceholder": "First name",
    "lastNameLabel": "Last name *",
    "lastNamePlaceholder": "Last name",
    "emailLabel": "Email *",
    "emailPlaceholder": "address@email.com",
    "emailHint": "A confirmation email will be sent if you change your address",
    "companyLabel": "Company (optional)",
    "companyPlaceholder": "Your company’s name",
    "postalCodeLabel": "Postal code *",
    "selectPostalCode": "Select a postal code",
    "selectCompanyTitle": "Select a company",
    "searchPostalCodePlaceholder": "Search a postal code",
    "otherCantonTitle": "Other canton",
    "noPostalCodeFound": "No postal code found",
    "searchCompanyPlaceholder": "Search a company",
    "addCompany": "Add “{{query}}”",
    "companyAddError": "Couldn’t add the company. Please try again.",
    "noCompanyFound": "No company found",
    "saveButton": "Save changes",
    "unsupportedFormatTitle": "Unsupported format",
    "unsupportedFormatMessage": "Choose an image in JPG, PNG or WEBP format.",
    "imageTooLargeTitle": "Image too large",
    "imageTooLargeMessage": "The image must be under 5 MB. Reduce its size and try again.",
    "uploadError": "Couldn’t upload the photo",
    "uploadGenericError": "Something went wrong during the upload",
    "fillRequiredFields": "Please fill in all the required fields",
    "photoUploadingTitle": "Photo still uploading",
    "photoUploadingMessage": "Wait a few seconds for the photo to finish uploading, then try again.",
    "emailUpdateError": "Couldn’t update your email: {{message}}",
    "emailUpdatedTitle": "Email updated",
    "emailUpdatedMessage": "A confirmation email has been sent to your new address. Confirm it to finalize the change.",
    "profileUpdated": "Profile updated successfully",
    "profileUpdatedWithEmail": "Profile updated. A confirmation email has been sent to your new address: confirm it to finalize the change.",
    "profileUpdateError": "Couldn’t update your profile",
    "genericError": "Something went wrong"
  },
  "editObjectives": {
    "title": "Choose your goal",
    "subtitle": "Set your impact: select the actions you want to complete each day.",
    "bronzeTitle": "Bronze: easing in",
    "bronzeRange": "1 to 3 actions",
    "silverTitle": "Silver: committed",
    "silverRange": "4 to 6 actions",
    "goldTitle": "Gold: all in",
    "goldRange": "7 to 9 actions"
  },
  "wheel": {
    "title": "Wheel of luck",
    "subtitle": "Daily prize draw",
    "spinCta": "Spin the wheel",
    "spinning": "Spinning...",
    "pointsUnit": "pts",
    "disclaimer": "Prize game organised by the Republic and Canton of Geneva. One entry per day. Apple and Google are not sponsors.",
    "wonTitle": "Congrats, you won!",
    "wonTitleA11y": "Congrats, you qualified for the prize draw",
    "formSubtitleExtraInfo": "You can enter today’s prize draw. Just two more details so we can hand over the gift if you win.",
    "formSubtitleConfirmEmail": "You can enter today’s prize draw. Confirm your email address so we can reach you if you win.",
    "ageLabel": "Age",
    "agePlaceholder": "e.g. 32",
    "genderLabel": "Gender",
    "gender": {
      "femme": "Woman",
      "homme": "Man",
      "autre": "Other",
      "prefereNePasDire": "Prefer not to say"
    },
    "emailLabel": "Email",
    "emailPlaceholder": "name@email.com",
    "emailA11y": "Email address",
    "submitCta": "Confirm my entry",
    "errors": {
      "ageRange": "Age must be between 13 and 120.",
      "genderRequired": "Gender is required.",
      "profileSaveFailed": "Couldn’t save your details. Please try again.",
      "invalidEmail": "Invalid email.",
      "consentRequired": "You need to agree to be contacted to take part.",
      "alreadyEntered": "An entry has already been recorded for this account.",
      "notAuthenticated": "You need to be logged in to take part.",
      "generic": "Something went wrong, please try again."
    },
    "doneTitle": "Entry recorded",
    "doneSubtitlePrefix": "Your spot in the prize draw is confirmed. If you win, we’ll contact you at",
    "accountEmailFallback": "your account email",
    "wonPointsPill": "+{{points}} points",
    "wonPointsSubtitle": "{{points}} points have been added to your total. Come back tomorrow to spin again.",
    "wonPointsCta": "Awesome!",
    "spentTitle": "Wheel already spun",
    "spentSubtitle": "One entry per day. Come back tomorrow to spin the wheel again.",
    "lockedTitle": "The wheel opens on 14 September",
    "lockedSubtitle": "The prize draw starts with the challenge. Come back on Monday to spin.",
    "lockedCta": "Got it",
    "closeA11y": "Close the window"
  },
  "celebration": {
    "title": "Congratulations!",
    "homeLink": "Home",
    "allDoneTitle": "All actions done!",
    "allDoneText": "You completed all 9 actions today, well done! The challenge continues tomorrow.",
    "resultsTitle": "Results",
    "totalPointsLabel": "Total points",
    "bonusLabel": "Loto bonus (complete line)",
    "bonusValue": "+{{points}} points",
    "zeroWasteLabel": "Zero waste points",
    "balancedLabel": "Balanced diet points",
    "localLabel": "Local food points",
    "weeklyActivityTitle": "This week’s activity",
    "medalsTitle": "Medals earned",
    "medalBronze": "Bronze",
    "medalSilver": "Silver",
    "medalGold": "Gold",
    "medalRangeBronze": "0-9 actions",
    "medalRangeSilver": "10-49 actions",
    "medalRangeGold": "50+ actions"
  },
  "goFurther": {
    "headerTitle": "Going further",
    "intro": "Here is some practical information and advice to help you adopt more responsible habits every day.",
    "consommactionSectionTitle": "Consomm’action guide",
    "consommactionPageTitle": "Consomm’action page",
    "consommactionPageDescription": "Discover the complete guide to responsible consumption",
    "eatSheetTitle": "Full fact sheet: EATING",
    "eatSheetDescription": "Everything you need to know about sustainable food",
    "reusableSectionTitle": "Reusable tableware",
    "reusableSectionText": "Everything about reusable tableware in the canton of Geneva:",
    "emportonsMalinTitle": "Emportons Malin",
    "emportonsMalinDescription": "Guide to deposit-based tableware and a map of restaurants",
    "engageSectionTitle": "Committing to a sustainable future",
    "ecoDefisTitle": "Eco-challenges",
    "ecoDefisDescription": "Take part in the canton’s ecological challenges",
    "climateTitle": "Nos Gestes Climat",
    "climateDescription": "Calculate your carbon footprint with Nos Gestes Climat",
    "datesSectionTitle": "Dates to remember",
    "tasteWeekTitle": "Swiss Taste Week",
    "tasteWeekDescription": "September 17-27, 2026",
    "foodWasteWeekTitle": "Food Waste Action Week",
    "foodWasteWeekDescription": "September 12-20, 2026",
    "questionTitle": "Any questions?",
    "contactButton": "Contact us",
    "noEmailAppMessage": "Couldn’t open your email app. You can reach us at app@repaschallenge.ch."
  },
  "partners": {
    "headerTitle": "Partners",
    "intro": "The REPAS challenge is an initiative of the Canton of Geneva, in partnership with several organizations committed to local, balanced and zero-waste food.",
    "openPartnerSite": "Open {{name}}’s website"
  },
  "gifts": {
    "headerTitle": "Gifts",
    "intro": "REPAS challenge: more than CHF 5,000 in prizes to be won! Gifts are up for grabs every working day.",
    "drawsTitle": "Prize draws",
    "drawsText": "The prize draws are carried out by the REPAS challenge team. Winners are notified by email."
  },
  "about": {
    "headerTitle": "Our approach",
    "introPrefix": "REPAS challenge is an",
    "introLink": "eco-challenge",
    "introSuffix": "launched by the Canton of Geneva to promote local, balanced and zero-waste food.",
    "paragraphAudience": "This initiative is open to all organizations, as well as to everyone who lives, works or passes through Geneva.",
    "paragraphAxes": "REPAS challenge is a simple and fun challenge built on three pillars, promoting nine behaviors:",
    "bulletLocal": "Local food: encouraging the purchase and consumption of local, seasonal products",
    "bulletBalanced": "Balanced food: promoting a healthy diet",
    "bulletZeroWaste": "Zero-waste food: reducing food waste and sorting waste.",
    "howTitle": "How does it work?",
    "howText": "It’s very simple! Each day, just select which of the nine suggested actions you have completed. Each action earns you points. When you complete a full line (all the actions of one pillar), you get bonus points. If you complete all the actions… you win!",
    "contactTitle": "Contact us",
    "contactText": "For any questions: GE - Eco-défis (DT)"
  },
  "rules": {
    "headerTitle": "Terms of use",
    "lastUpdate": "Last updated: September 2026",
    "section1Title": "1. About",
    "section1Body": "REPAS challenge is a free app provided by the Canton of Geneva. It aims to encourage sustainable and responsible eating habits in everyday life.",
    "section2Title": "2. Free of charge",
    "section2Body": "Using REPAS challenge is entirely free. No in-app purchases are offered.",
    "section3Title": "3. Sign-up",
    "section3Body": "Signing up requires a valid email address. Keeping your login credentials confidential is your responsibility.",
    "section4Title": "4. Rules of use",
    "section4Intro": "Using REPAS means agreeing to:",
    "section4Bullet1": "Use the app honestly and fairly",
    "section4Bullet2": "Not create several accounts for the same person",
    "section4Bullet3": "Only report actions you have actually completed",
    "section4Bullet4": "Respect the other participants",
    "section5Title": "5. Fair play and moderation",
    "section5Body": "REPAS challenge is built on trust and everyone’s commitment. The Canton of Geneva reserves the right to suspend or delete any account whose use is deemed contrary to the spirit of the project or to these terms.",
    "section6Title": "6. Ranking and prizes",
    "section6Body1": "Taking part in the ranking is optional. You can change your visibility at any time in the settings.",
    "section6Body2": "During the challenge, prizes will be awarded to participants by prize draw (see the Gifts section).",
    "section6Body3": "Points have no monetary value and rewards cannot be exchanged for money or goods.",
    "section6Body4": "The prize game (lucky wheel and prize draw) is organised by the Republic and Canton of Geneva. It is open to people aged 13 and over, with one entry per day. Apple and Google are not sponsors or organisers of this prize game and are not involved in any way.",
    "section7Title": "7. Intellectual property",
    "section7Body": "The REPAS challenge app, its content and its design are the property of the Canton of Geneva. Any unauthorized reproduction is prohibited.",
    "section8Title": "8. Limitation of liability",
    "section8Body": "The Canton of Geneva does its utmost to keep the app running smoothly but cannot guarantee permanent availability. You use the app at your own responsibility.",
    "section9Title": "9. Changes",
    "section9Body": "These terms may be changed at any time. You will be informed of any significant changes.",
    "section10Title": "10. Governing law",
    "section10Body": "These terms are governed by Swiss law. Any dispute falls under the exclusive jurisdiction of the Geneva courts."
  },
  "privacy": {
    "headerTitle": "Privacy policy",
    "lastUpdate": "Last updated: September 2026",
    "section1Title": "1. Data controller",
    "section1Body": "REPAS challenge is an initiative of the Canton of Geneva aimed at encouraging sustainable eating habits. The data is hosted in Switzerland.",
    "section2Title": "2. Data collected",
    "section2Intro": "We only collect the data needed for the app to work:",
    "section2Bullet1": "Account information (first name, last name, email, etc.)",
    "section2Bullet2": "Postal code and company (optional)",
    "section2Bullet3": "Daily actions recorded",
    "section2Bullet4": "Points and progress",
    "section3Title": "3. How your data is used",
    "section3Intro": "The data collected is used exclusively for:",
    "section3Bullet1": "Running the app and the gift prize draws",
    "section3Bullet2": "Displaying the ranking",
    "section3Bullet3": "Anonymized statistics for improvement purposes",
    "section3Emphasis": "No advertising tracking is carried out and no data is sold. Some data is processed by our technical sub-processors — Supabase (hosting, Switzerland), Amplitude (usage analytics) and Sentry (error reporting) — solely to operate and improve the app.",
    "section4Title": "4. Hosting and security",
    "section4Body": "All data is stored on secure servers located in Switzerland. Communications are encrypted via HTTPS.",
    "section5Title": "5. Your rights",
    "section5Intro": "In accordance with the Swiss data protection act (FADP), you can:",
    "section5Bullet1": "Access your data through your profile",
    "section5Bullet2": "Update your information at any time",
    "section5Bullet3": "Delete your account and data in the settings",
    "section6Title": "6. Data retention",
    "section6Body": "Your data is kept as long as your account is active. If you delete your account, your data is anonymized to preserve the integrity of the overall statistics.",
    "section7Title": "7. Contact",
    "section7Body": "For any questions about your data, contact us through the app or at repaschallenge.ch"
  },
  "actions": {
    "categories": {
      "local": "Local food",
      "balanced": "Balanced diet",
      "zeroWaste": "Zero waste"
    },
    "grta": {
      "name": "GRTA products",
      "description": "To win, simply eat a GRTA product (Genève Région Terre Avenir).",
      "infoLabel": "The Geneva local produce portal"
    },
    "ambassadeurs": {
      "name": "Terroir ambassadors",
      "description": "To win, simply eat at one of the “Ambassadeurs du terroir” restaurants.",
      "infoLabel": "Ambassadeurs du Terroir"
    },
    "venteFerme": {
      "name": "Farm-gate sales",
      "description": "To win, simply eat a product bought from a local point of sale.",
      "infoLabel": "Local produce points of sale"
    },
    "repasEquilibre": {
      "name": "Balanced meal",
      "description": "To win, simply eat a balanced meal that follows the Swiss food pyramid.",
      "infoLabel": "Swiss Society for Nutrition"
    },
    "nutriScore": {
      "name": "Nutri-Score",
      "description": "To win, simply eat a product with a Nutri-Score A.",
      "infoLabel": "Nutri-Score"
    },
    "proteineVegetale": {
      "name": "Plant protein",
      "description": "To win, simply eat a plant protein that replaces meat/fish/egg.",
      "infoLabel": "Fourchette verte Genève"
    },
    "contenantReutilisable": {
      "name": "Reusable container",
      "description": "To win, simply eat a meal from a reusable container: tupperware, reCIRCLE box, plate or bowl.",
      "infoLabel": "Emportons malin !"
    },
    "compost": {
      "name": "Compost",
      "description": "To win, simply put your kitchen waste in a compost.",
      "infoLabel": "Kitchen waste"
    },
    "pasDeGaspillage": {
      "name": "No waste",
      "description": "To win, simply eat a meal without wasting anything.",
      "infoLabel": "Food waste"
    }
  },
  "apps": {
    "yuka": {
      "tagline": "Scan your products and decode what is in them"
    },
    "myswissfood": {
      "tagline": "Learn more about balanced, varied and tasty eating"
    },
    "toogoodtogo": {
      "tagline": "Rescue meals from being wasted, at a low price"
    },
    "frigomagic": {
      "tagline": "Quick recipes tailored to whatever is in your fridge"
    },
    "nosgestesclimat": {
      "tagline": "Work out your carbon footprint and how to shrink it"
    },
    "vaisselle": {
      "tagline": "Tips and information on reusable tableware"
    },
    "geneveterroir": {
      "tagline": "Explore Geneva’s local produce and producers"
    },
    "poubelleverte": {
      "tagline": "How to sort kitchen waste in Geneva"
    },
    "calendriersaisons": {
      "tagline": "Seasonal fruit, vegetables and herbs in Switzerland"
    }
  }
}
